import { reportClientError } from '../../../app/_components/chrome/scripts/DataDogRumScript'
import { type Translations } from '../../../app/_providers/TranslationProvider.client'

export const getAuthCodeParam = () => new window.URLSearchParams(location.search).get('code')

export const onIdmeError = (
  error: Error,
  setStatusText: (statusText: string) => void,
  strings: Translations['idme']
) => {
  setStatusText(strings.failure)
  reportClientError({
    error,
    context: {
      scope: 'IdmePage',
      label: `createIdmeShopifyDiscountCode`,
    },
  })
}

export const onIdmeSuccess = (
  data: { createIdmeShopifyDiscountCode: string | null },
  setStatusText: (statusText: string) => void,
  setDiscountCode: (discountCode: string) => void,
  strings: Translations['idme']
) => {
  const discountCode = data.createIdmeShopifyDiscountCode

  if (!discountCode) {
    setStatusText(strings.failure)
    reportClientError({
      error: new Error('createIdmeShopifyDiscountCode returned null'),
      context: {
        scope: 'IdmePage',
        label: `createIdmeShopifyDiscountCode`,
      },
    })
    return
  }

  setStatusText(strings.success)
  setDiscountCode(discountCode)
}
